import { RouterV2Enum, RouterV3Enum } from '@/router/router-names';

/** 是否是需要显示底部tabbar的路由path */
export default (path: string): boolean => {
  if (path === RouterV2Enum.qualityHomePage
    || path === RouterV2Enum.taglessHome
    || path === RouterV2Enum.home
    || path === RouterV2Enum.myProfile
    || path === RouterV3Enum.home) {
    return true;
  }

  return false;
};
